export default function augmentProgress(width) {
  const progress = document.querySelector('#progress');
  progress.style.width = width + '%';
}
